var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","position":"relative"}},[_c('img',{staticClass:"background",attrs:{"src":require("../../../static/img/background.png")}}),_vm._v(" "),_c('company-intro'),_vm._v(" "),_c('detail-intro'),_vm._v(" "),_c('bottom-info',{staticStyle:{"position":"absolute","top":"1860px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27fd9643","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Intro/aboutUs.vue
// module id = null
// module chunks = 